import React from "react";
import { observer } from "mobx-react";
import { EditionDocumentTypeViewStore } from "../../store";
import { EditionDocumentTypeViewForm } from "./EditionDocumentTypeViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type EditionDocumentTypeViewProps = {
  editionDocumentTypeViewStore: EditionDocumentTypeViewStore;
};

export const EditionDocumentTypeView: React.FC<EditionDocumentTypeViewProps> =
  observer(({ editionDocumentTypeViewStore }) => {
    return (
      <div>
        <EditionDocumentTypeViewForm
          name={editionDocumentTypeViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            editionDocumentTypeViewStore.printEditionDocumentType(handlePrint)
          }
          onCancel={() =>
            editionDocumentTypeViewStore.cancelEditionDocumentType()
          }
          onEdit={
            editionDocumentTypeViewStore.isEditEnabled
              ? () => editionDocumentTypeViewStore.editEditionDocumentType()
              : undefined
          }
        />
        <ErrorDialog
          open={editionDocumentTypeViewStore.errorDialogOpened}
          title={editionDocumentTypeViewStore.errorTitle}
          description={editionDocumentTypeViewStore.errorDescription}
          onClose={() => editionDocumentTypeViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
